<template>
  <div id="header-top" class="container-wrapper">
    <a href="http://cpc.rd.wanfangdata.com.cn/edu" target="_blank"
      ><div class="header-left"><img src="./imgs/logo-WF.png" /></div
    ></a>
    <div class="header-center" v-show="$route.name !== 'Home'">
      <img src="./imgs/titile-sm.png" />
    </div>
    <div class="header-right">
      <router-link to="/" tag="div" v-show="$route.name !== 'Home'"
        >首页</router-link
      >
      <!-- <router-link to="/book" tag="div">整书浏览</router-link>
      <router-link to="/entry" tag="div">条目浏览</router-link> -->
        <p @click="jumpHandle('/book')" style="padding: 0 14px 0 35px;">整书浏览</p>
        <p @click="jumpHandle('/entry')" style="padding: 0px 0 0 21px;">条目浏览</p>
      <div
        v-if="userinfolength > 0"
        class="users"
        @click="showUserList = !showUserList"
      >
        <span class="iconfont" style="font-size: 20px">&#xe610;</span>
        <span class="init-name">{{ userinfo.users[0].institution }}</span>
        <span class="iconfont" v-if="!showUserList && userinfolength > 1"
          >&#xe68d;</span
        >
        <span class="iconfont" v-if="showUserList && userinfolength > 1"
          >&#xe68e;</span
        >
      </div>
      <div
        class="logout"
        @click="handleClickLoginOut"
        v-if="userinfolength > 0"
      >
        退出
      </div>
      <div class="login" @click="handleClickLogin">登录</div>
    </div>
    <transition name="showUser">
      <div class="user-wrapper" v-show="showUserList">
        <div
          v-show="index != 0"
          v-for="(item, index) of userinfo.users"
          :key="index"
        >
          {{ item.institution }}
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { LOGIN_OUT_URL, RESOURCE_TYPE_ITEM_DOWN, READ_URL, RESOURCE_TYPE_ITEM_READ, LOGIN_IN_URL, RESOURCE_TYPE_READ } from '../../assets/constant'
export default {
  name: 'Header',
  data () {
    return {
      showUserList: false,
      userinfolength: ''
    }
  },
  mounted () {
    this.$store.dispatch('getUserInfo')
    this._initToReading()
    this._isLogin()
    this._isSearch()
  },
  created () {
    this.getUserInfo()
    if (this.userinfo.users === undefined) {
      this.userinfolength = 0
    } else {
      this.userinfolength = this.userinfo.users.length
    }
  },
  computed: {
    ...mapState(['userinfo', 'book_id', 'upCouter', 'readingType', 'filterList'])
  },
  watch: {
    $route: {
      handler: function (val) {
        this._isSearch()
      },
      deep: true
    }
  },
  methods: {
    _isSearch () {
      if (this.$route.name !== 'SearchItem') {
        if (this.filterList.length !== 0) {
          for (var i = 0; i < this.filterList.length; i++) {
            this.filterList.splice(i, 1)
          }
          localStorage.setItem(`filterList`, JSON.stringify(this.filterList))
        }
      }
    },
    // 判断用户是否登录
    _isLogin () {
      let counter = 0
      this.$store.dispatch('saveCurrentBookId', counter)
      this.$store.dispatch('saveCounter', counter)
    },
    // 刷新页面跳转阅读页
    _initToReading () {
      if (!this.$route.query.service) {
        return
      }
      if (this.upCouter && this.book_id && this.readingType === 1) {
        window.open(READ_URL + this.book_id + RESOURCE_TYPE_ITEM_READ)
      }
      if (this.upCouter && this.book_id && this.readingType === 2) {
        window.open(READ_URL + this.book_id + RESOURCE_TYPE_READ)
      }
      if (this.upCouter && this.book_id && this.readingType === 3) {
        window.location.href = READ_URL + this.book_id + RESOURCE_TYPE_ITEM_DOWN
      }
    },
    // 设置cookie值
    setCookie (cname, cvalue) {
      var d = new Date()
      d.setTime(d.getTime() + (30 * 60 * 1000))
      var expires = 'expires=' + d.toUTCString()
      document.cookie = cname + '=' + cvalue + '; ' + expires + ';path=/;domain=wanfangdata.com.cn'
    },
    getUserInfo () {
      this.$http.get('/api/v1/users?' + new Date().getMilliseconds()).then((res) => {
        if (res.status === 200 && res.data) {
          const data = res.headers.cookie
          if (data !== undefined) {
            this.setCookie('CASTGC', data)
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 登录
    handleClickLogin () {
      const urlinner = window.location.href
      const inner = window.encodeURIComponent(urlinner)
      const url = LOGIN_IN_URL + inner
      window.location.href = url
    },
    handleClickLoginOut () {
      const urlinner = window.location.origin + '/' + window.location.pathname.split('/')[1]
      const inner = window.encodeURIComponent(urlinner)
      const url = LOGIN_OUT_URL + inner
      window.location.href = url
    },
    //点击跳转整书 条目 浏览
    async jumpHandle(path) {
      if (await this.$loginAuthentication.intercept(0)) {
        this.$router.push({
          path: path,
        });
      }
    }
  }
}
</script>

<style lang="less" scoped>
#header-top {
  height: 60px;
  line-height: 60px;
  position: relative;
  .header-left,
  .header-center {
    cursor: pointer;
    float: left;
  }
  .header-center {
    img {
      border-left: 1px solid #dddddd;
      margin-left: 22px;
      padding-left: 23px;
    }
  }
  .header-right {
    float: right;
    height: 60px;
    >p{
      display: inline-block;
      font-size: 16px;
      padding: 0 14px;
      height: 18px;
      cursor: pointer;
      float: left;
      color: #003b83;
    }
    div {
      float: left;
      color: #003b83;
      font-size: 16px;
      margin-left: 35px;
      cursor: pointer;
      &:hover {
        color: rgb(1, 23, 49, 0.8);
      }
    }
    .users {
      max-width: 180px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      display: inline-block;
    }
  }
}
.user-wrapper {
  position: absolute;
  box-sizing: border-box;
  z-index: 2;
  margin-left: 0px;
  width: 200px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 6px 0px rgba(83, 83, 83, 0.82);
  border-radius: 2px;
  right: 0;
  padding: 0 6px;
  top: 55px;
  right: 108px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 59, 131, 1);
  div {
    width: 200px;
    margin-left: 0px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    display: block;
    border-bottom: 1px solid #eeeeee;
    background: #fff;
    //text-align: center;
    text-indent: 16px;
  }
}
.showUser-enter,
.showUser-leave-to {
  opacity: 0;
}
.showUser-enter-to,
.showUser-leave {
  opacity: 1;
}
.showUser-enter-active,
.showUser-leave-active {
  transition: all 0.3s;
}
/*适应宽度*/
@media screen and (max-width: 1365px) {
}
@media screen and (min-width: 1366px) and (max-width: 1599px) {
  #search {
    padding-bottom: 18px !important;
  }
}
@media screen and (min-width: 1600px) and (max-width: 1919px) {
}
@media screen and (min-width: 1920px) {
}
</style>



// WEBPACK FOOTER //
// src/components/Header/Header.vue